var exports = {
  "Y9": "Header__NR7RG-",
  "az": "Box__4EDKLV",
  "wy": "Box_1___vyaEZ",
  "DZ": "Heading__ss4Pi-",
};

module.exports = exports;
